import { useCallback } from "react";

const toDateSafe = (val) => {
  if (!val) return null;
  const d = val instanceof Date ? val : new Date(val);
  return Number.isNaN(d.getTime()) ? null : d;
};

const formatShort = (d, opt = {}) =>
  d
    .toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      ...opt,
    })
    .replace(".", "");

export const useReservationDateDisplayValue = () =>
  useCallback((startDate, endDate) => {
    const s = toDateSafe(startDate);
    const e = toDateSafe(endDate);

    if (!s || !e) return "-";

    const sameMonth = s.getMonth() === e.getMonth();
    const sameYear = s.getFullYear() === e.getFullYear();

    if (sameMonth && sameYear) {
      const month = e
        .toLocaleDateString("fr-FR", { month: "short" })
        .replace(".", "");
      return `${s.getDate()}-${e.getDate()} ${month} ${e.getFullYear()}`;
    }

    return `${formatShort(s, { year: "numeric" })} - ${formatShort(e, { year: "numeric" })}`;
  }, []);
